import { computed, inject, reactive } from 'vue'

import AuthLoginComponent from '@/components/auth/blocks/login/login.vue'
import AuthRegisterComponent from '@/components/auth/blocks/register/register.vue'

export default {
  name: 'AuthLoginRegisterComponent',
  components: {
    AuthLoginComponent,
    AuthRegisterComponent,
  },
  props: {
    options: {
      type: Object,
      required: false,
      default: null,
    },
    activeTab: {
      type: String,
      required: false,
      default: 'register',
    },
  },
  setup (props) {
    console.log('options', props.options)
    const authProvider = inject('authProvider')

    const state = reactive({
      active: props.activeTab,
      user: computed(() => authProvider().getUser),
    })

    return { state }
  },
  methods: {
    login: async function (data) {
      this.$emit('login', data)
    },
    register: async function (data) {
      this.$emit('register', data)
    },
  },
}
